import { React, useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
// import './ShowChalan.css'
import ChalanRasid from "./ChalanRasid";
import { setChalanDetail } from "../../storeSlices/chalanSlice";
//import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//import { setlocalChalanDetail } from "../../storeSlices/localChalanSlice";
import Printchallanrasid from "./PrintChalanRasid";
import {
  Button,
  //Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";

const classes = {
  cardContainer: {
    boxSizing: "border-box",
    boxShadow:
      "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
    borderRadius: "1rem",
    padding: "1vmax",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
  printContainer: {
    position: "absolute",
    height: "100%",
    overflow: "scroll",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
  },
  formContainer: {
    position: "absolute",
    height: "100%",
    overflow: "scroll",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  },
};
function ShowChalan({ challan }) {
  //
  const [details, setdetails] = useState({
    gst_no: challan.gst_no || "",
    pan_no: challan.pan_no || "",
    gr_date: challan.gr_date || "",
    date: challan.date || "",
    invoice_no: challan.invoice_no || "",
    invoice_date: challan.invoice_date || "",
    client_details: challan.client_details || "",
    challan_number: challan.challan_number || "",
    cin_no: challan.cin_no || "",
    gr_no: challan.gr_no || "",
    truck_no: challan.truck_no || "",
    freight_mode: challan.freight_mode || "",
    freight_type: challan.freight_type || "",
    transporter: challan.transporter || "",
    vessel_name: challan.vessel_name || "",
    driver_name: challan.driver_name || "",
    entery_bill_no: challan.entery_bill_no || "",
    exporter_name: challan.exporter_name || "",
    e_way_bill_no: challan.e_way_bill_no || "",
    billed_to: challan.billed_to || "",
    billed_to_address: challan.billed_to_address || "",
    billed_state: challan.billed_state || "",
    billed_code: challan.billed_code || "",
    billed_pan: challan.billed_pan || "",
    billed_gst: challan.billed_gst || "",
    delivery_to_address: challan.delivery_to_address || "",
    delivery_to: challan.delivery_to || "",
    delivery_state: challan.delivery_state || "",
    delivery_code: challan.delivery_code || "",
    delivery_pan: challan.delivery_pan || "",
    delivery_gst: challan.delivery_gst || "",
    description_of_goods: challan.description_of_goods || "",
    hsn_code: challan.hsn_code || "",
    qty: challan.qty || "",
    uom: challan.uom || "",
    rate: challan.rate || "",
    amount: challan.amount || "",
    total_challan_amount: challan.total_challan_amount || "",
    cessNonAdvol: challan.cessNonAdvol || "",
    cessRate: challan.cessRate || "",
    sgstRate: challan.sgstRate || "",
    igstRate: challan.igstRate || "",
    updatedby: challan.updatedby || "",
  });

  //calculation

  const profileDetails = useSelector((state) => state.dataReducer.profile);

  useEffect(() => {
    if (details.rate !== "" && details.qty !== "") {
      const amount = details?.rate * details?.qty;
      setdetails((prevdetails) => ({
        ...prevdetails,
        amount: amount,
      }));
    }
  }, [details.rate, details.qty]);

  useEffect(() => {
    if (
      details.amount !== "" &&
      details.sgstRate !== "" &&
      details.igstRate !== "" &&
      details.cessRate !== "" &&
      details.cessNonAdvol !== ""
    ) {
      const total =
        details?.amount +
        (details?.amount * details?.sgstRate * 2) / 100 +
        (details?.amount * details?.igstRate) / 100 +
        (details?.amount * details?.cessRate) / 100 +
        Number(details?.cessNonAdvol * details?.qty);
      setdetails((prevdetails) => ({
        ...prevdetails,
        total_challan_amount: total,
      }));
    }
  }, [
    details.amount,
    details.sgstRate,
    details.igstRate,
    details.cessRate,
    details.cessNonAdvol,
    details.qty,
  ]);

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };

  //

  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);

  // const handleOpen = () => setOpen(true);
  const handleClose = () => {
    console.log("first");
    setOpen(false);
  };

  // useEffect(() => {
  //   console.log("useEffect hasbeen called");
  // }, [open2]);
  // setTimeout(() => {
  //   setOpen2(false);
  // }, 5000);
  const handleClose2 = () => {
    setOpen2(false);
    console.log("open2  from handleclose: ", open2);
  };
  const dispatch = useDispatch();
  //const navigate = useNavigate();
  const printChallan = (props) => () => {
    setOpen2(true);
    // console.log("props : ", props);
  };
  const editChallan = (props) => () => {
    console.log("editpage : ", props);
    dispatch(setChalanDetail(props));
    setOpen(true);
    // navigate("/dashbaord/chalan/generatechalan");
  };
  // const generateLocalChallan = (props) => () => {
  //   const getDetail = {
  //     challan_number: props.challan_number,
  //     vehicle_number: props.truck_no,
  //     owner_name_name_address: "",
  //     owner_mobile_number: "",
  //     driver_name: props.driver_name,
  //     driver_mobile_number: "",
  //     gr_no: props.gr_no,
  //     goods_loaded_from: "",
  //     goods_loaded_to: "",
  //     cargo_freight: "",
  //     gr_no: props.gr_no,
  //     consignment: props.entery_bill_no,
  //     weight: props.qty,
  //     rate: props.rate,
  //     total_freight: "",
  //     advanced_freight: "",
  //     deisel: "",
  //     commision: "",
  //     balance_freight: "",
  //   };
  //   dispatch(setlocalChalanDetail(getDetail));
  //   navigate("/dashbaord/chalan/localchalan");
  //   console.log("generateLocalChallan : ", props);
  // };

  //
  const handleSubmit = async (event) => {
    event.preventDefault();

    // console.log(details);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/challan/${challan.id}`,
      //`http://localhost:5000/localchallan/${localchallanId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );

    const json = await response.json();
    console.log("challan12", json);

    // first validate chalan details
    // dispatch(validateLocalChalanDetail(details));

    // set chalan details
    dispatch(setChalanDetail(details));

    document.getElementById("bill-form").classList.toggle("c-form");
    document.getElementById("bill-template").classList.toggle("bill");
  };

  //

  return (
    <Box className="ch-bx" sx={classes.cardContainer}>
      <CardContent>
        <Typography variant="h6">
          <b>Eway Bill Number ⇝ {details.e_way_bill_no}</b>
        </Typography>
        <Typography variant="h6">
          <b>Challan Number Number ⇝ {details.challan_number}</b>
        </Typography>
        <Typography variant="h6">
          <b>Total Challan Amount ⇝ {details.total_challan_amount}</b>
        </Typography>
        <Typography variant="h6">
          <b>Updated By ⇝ {details.updatedby}</b>
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="large" onClick={editChallan(challan)}>
          Edit
        </Button>
        <Button size="large" onClick={printChallan(challan)}>
          Print
        </Button>
        {/* <Button size="large" onClick={generateLocalChallan(challan)}>
          localChalan
        </Button> */}
      </CardActions>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={classes.formContainer}>
          <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
            <label style={{ marginTop: "10px" }}>
              E-way Bill Number
              <input
                type="text"
                name="e_way_bill_no"
                value={details.e_way_bill_no}
                onChange={handleChange}
              />
            </label>
            <label>
              {/* E-way Bill No: */}
              {
                // JSON.stringify(EwayBillDetails) === {} ? (
                //   <input
                //     type="text"
                //     name="e_way_bill_no"
                //     value={details.e_way_bill_no}
                //     onChange={handleChange}
                //   />
                // ) :
                //(
                // <>
                //   <input type="text" list="e_way_bill_no" />
                //   <datalist
                //     name="e_way_bill_no"
                //     id="e_way_bill_no"
                //     onChange={handleChange}
                //   >
                //     {Object.entries(EwayBillDetails.num).map((item, index) => {
                //       //here we convert object to array and then map it to get the values, how to get last value
                //       if (
                //         index + 1 ===
                //         Object.entries(EwayBillDetails.num).length
                //       ) {
                //         return (
                //           <option
                //             name="e_way_bill_no"
                //             key={index}
                //             value={item[1].ewaybillno}
                //           >
                //             {/* {setewaybillnu(item[1].ewaybillno)} */}
                //             {item[1].ewaybillno}
                //           </option>
                //         );
                //       }
                //     })}
                //   </datalist>
                // </>
                // )
              }
            </label>
            <br />
            {/* <label>
          Client Details
          {JSON.stringify(partyDetails) === {} ? (
            <input
              type="text"
              name="client_details"
              value={details.client_details}
              onChange={handleChange}
            />
          ) : (
            <>
              <input type="text" list="client_name" />
              <datalist
                name="client_details"
                id="client_name"
                onChange={handleChange}
              >
                {Object.entries(partyDetails.client).map((item, index) => {
                  return (
                    <option
                      name="client_details"
                      key={index}
                      value={item[1].name}
                    >
                      {item[1].name}
                    </option>
                  );
                })}
              </datalist>
            </>
          )}
        </label>
        <br /> */}
            <label>
              Bill of Entry No:
              <input
                type="text"
                name="entery_bill_no"
                value={details.entery_bill_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              date
              <input
                type="date"
                name="date"
                value={details.date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GST No:
              <input
                type="text"
                name="gst_no"
                value={details.gst_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Pan No:
              <input
                type="text"
                name="pan_no"
                value={details.pan_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Cin No:
              <input
                type="text"
                name="cin_no"
                value={details.cin_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Gr No:
              <input
                type="text"
                name="gr_no"
                value={details.gr_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GR date:
              <input
                type="text"
                name="gr_date"
                value={details.gr_date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Invoice Number
              <input
                type="text"
                name="invoice_no"
                value={details.invoice_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Invoice Date
              <input
                type="text"
                name="invoice_date"
                value={details.invoice_date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Challan No
              <input
                type="text"
                name="challan_number"
                value={details.challan_number}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Truck No:
              <input
                type="text"
                name="truck_no"
                value={details.truck_no}
                onChange={handleChange}
              />
              {/* {JSON.stringify(trucksDetails) === {} ? (
            <input
              type="text"
              name="truck_no"
              value={details.truck_no}
              onChange={handleChange}
            />
          ) : (
            <>
              <input type="text" list="gaadi_no" />
              <datalist name="truck_no" id="gaadi_no" onChange={handleChange}>
                {Object.entries(trucksDetails.car).map((item, index) => {
                  return (
                    <option
                      name="truck_no"
                      key={index}
                      value={item[1].gaadi_no}
                    >
                      {item[1].gaadi_no}
                    </option>
                  );
                })}
              </datalist>
            </>
          )} */}
            </label>
            <br />
            <label>
              Freight Mode:
              <input
                type="text"
                name="freight_mode"
                value={details.freight_mode}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Freight Type:
              <input
                type="text"
                name="freight_type"
                value={details.freight_type}
                onChange={handleChange}
              />
            </label>
            <br />
            {/* <label>
          Goods:
          <input
            type="text"
            name="goods"
            value={details.goods}
            onChange={handleChange}
          />
        </label>
        <br /> */}
            <label>
              Transporter Name:
              <input
                type="text"
                name="transporter"
                value={details.transporter}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Vessel Name:
              <input
                type="text"
                name="vessel_name"
                value={details.vessel_name}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Exporter Name:
              <input
                type="text"
                name="exporter_name"
                value={details.exporter_name}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              {profileDetails &&
              profileDetails.pro &&
              profileDetails.pro["name"] ===
                "SHREE MAHAVEER TRANSPORT COMPANY" ? (
                <h2>Billed To:</h2>
              ) : (
                <h2>Billed From:</h2>
              )}
              {/* <h2> Billed From:</h2> */}
              <input
                type="text"
                name="billed_to"
                value={details.billed_to}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Address
              <input
                type="text"
                name="billed_to_address"
                value={details.billed_to_address}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              State:
              <input
                type="text"
                name="billed_state"
                value={details.billed_state}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Code:
              <input
                type="number"
                name="billed_code"
                value={details.billed_code}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GST Number:
              <input
                type="text"
                name="billed_gst"
                value={details.billed_gst}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              PAN Number:
              <input
                type="text"
                name="billed_pan"
                value={details.billed_pan}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Weight:
              <input
                type="number"
                name="weight"
                value={details.weight}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Driver Name:
              <input
                type="text"
                name="driver_name"
                value={details.driver_name}
                onChange={handleChange}
              />
              {/* <input
            type="text"
            name="driver_name"
            value={details.driver_name}
            onChange={handleChange}
          /> */}
              {/* <select name="driver_name" id="Driver_name" onChange={handleChange}>
            {Object.entries(driverDetails.drive).map((item, index) => {
              return (
                <option
                  name="driver_name"
                  key={index}
                  value={item[1].driver_name}
                >
                  {item[1].name}
                </option>
              );
            })}
          </select> */}
            </label>
            <br />
            <label>
              {profileDetails &&
              profileDetails.pro &&
              profileDetails.pro["name"] ===
                "SHREE MAHAVEER TRANSPORT COMPANY" ? (
                <h2>Delivery To:</h2>
              ) : (
                <h2>Billed and Delivery To:</h2>
              )}
              {/* <h2> Delivery To:</h2> */}
              <input
                type="text"
                name="delivery_to"
                value={details.delivery_to}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Address
              <input
                type="text"
                name="delivery_to_address"
                value={details.delivery_to_address}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              State:
              <input
                type="text"
                name="delivery_state"
                value={details.delivery_state}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Code:
              <input
                type="number"
                name="delivery_code"
                value={details.delivery_code}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GST Number:
              <input
                type="text"
                name="delivery_gst"
                value={details.delivery_gst}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              PAN Number:
              <input
                type="text"
                name="delivery_pan"
                value={details.delivery_pan}
                onChange={handleChange}
              />
            </label>
            <br />
            <br />
            <label>
              Description Of Goods:
              <input
                type="text"
                name="description_of_goods"
                value={details.description_of_goods}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              HSN CODE:
              <input
                type="text"
                name="hsn_code"
                value={details.hsn_code}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              QTY:
              <input
                type="number"
                name="qty"
                value={details.qty}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              UOM:
              <input
                type="text"
                name="uom"
                value={details.uom}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              rate:
              <input
                type="number"
                name="rate"
                value={details.rate}
                onChange={handleChange}
              />
            </label>
            <br />
            <div>
              <table>
                <thead>
                  <tr>
                    <th>CGST+ SGST Rate(%) </th>
                    <th>IGST Rate(%)</th>
                    <th>CESS Advol Rate(%)</th>
                    <th>CESS non.Advol. Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <select
                        className="selectt"
                        name="sgstRate"
                        id="document-type"
                        onChange={handleChange}
                        value={details.sgstRate}
                      >
                        <option name="sgstRate" value="-1">
                          -Select-
                        </option>
                        <option name="sgstRate" value="0.500">
                          0.500 + 0.500
                        </option>
                        <option name="sgstRate" value="0.750">
                          0.750 + 0.750
                        </option>
                        <option name="sgstRate" value="3.750">
                          3.750 + 3.750
                        </option>
                        <option name="sgstRate" value="0.000">
                          0 + 0{" "}
                        </option>
                        <option name="sgstRate" value="2.500">
                          2.500 + 2.500
                        </option>
                        <option name="sgstRate" value="6.000">
                          6 + 6{" "}
                        </option>
                        <option name="sgstRate" value="9.000">
                          9 + 9{" "}
                        </option>
                        <option name="sgstRate" value="14.000">
                          14 + 14{" "}
                        </option>
                        <option name="sgstRate" value="1.500">
                          1.500 + 1.500
                        </option>
                        <option name="sgstRate" value="0.050">
                          0.050 + 0.050
                        </option>
                        <option name="sgstRate" value="0.125">
                          0.125 + 0.125
                        </option>
                        <option name="sgstRate" value="3.000">
                          3 + 3{" "}
                        </option>
                        <option name="sgstRate" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="selectt"
                        name="igstRate"
                        id="document-type"
                        onChange={handleChange}
                        value={details.igstRate}
                      >
                        <option name="igstRate" value="-1">
                          -Select-
                        </option>
                        <option name="igstRate" value="1.000">
                          1
                        </option>
                        <option name="igstRate" value="1.500">
                          1.500
                        </option>
                        <option name="igstRate" value="7.500">
                          7.500
                        </option>
                        <option name="igstRate" value="0.000">
                          0
                        </option>
                        <option name="igstRate" value="5.000">
                          5
                        </option>
                        <option name="igstRate" value="12.000">
                          12
                        </option>
                        <option name="igstRate" value="18.000">
                          18
                        </option>
                        <option name="igstRate" value="28.000">
                          28
                        </option>
                        <option name="igstRate" value="3.000">
                          3
                        </option>
                        <option name="igstRate" value="0.100">
                          0.100
                        </option>
                        <option name="igstRate" value="0.250">
                          0.250
                        </option>
                        <option name="igstRate" value="6.000">
                          6
                        </option>
                        <option name="igstRate" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="selectt"
                        name="cessRate"
                        id="document-type"
                        onChange={handleChange}
                        value={details.cessRate}
                      >
                        <option value="-1">-Select-</option>
                        <option
                          selected="selected"
                          value="0.000"
                          name="cessRate"
                        >
                          0
                        </option>
                        <option name="cessRate" value="1.000">
                          1
                        </option>
                        <option name="cessRate" value="3.000">
                          3
                        </option>
                        <option name="cessRate" value="5.000">
                          5
                        </option>
                        <option name="cessRate" value="11.000">
                          11
                        </option>
                        <option name="cessRate" value="12.000">
                          12
                        </option>
                        <option name="cessRate" value="12.500">
                          12.500
                        </option>
                        <option name="cessRate" value="15.000">
                          15
                        </option>
                        <option name="cessRate" value="17.000">
                          17
                        </option>
                        <option name="cessRate" value="20.000">
                          20
                        </option>
                        <option name="cessRate" value="21.000">
                          21
                        </option>
                        <option name="cessRate" value="22.000">
                          22
                        </option>
                        <option name="cessRate" value="36.000">
                          36
                        </option>
                        <option name="cessRate" value="49.000">
                          49
                        </option>
                        <option name="cessRate" value="60.000">
                          60
                        </option>
                        <option name="cessRate" value="61.000">
                          61
                        </option>
                        <option name="cessRate" value="65.000">
                          65
                        </option>
                        <option name="cessRate" value="71.000">
                          71
                        </option>
                        <option name="cessRate" value="72.000">
                          72
                        </option>
                        <option name="cessRate" value="89.000">
                          89
                        </option>
                        <option name="cessRate" value="96.000">
                          96
                        </option>
                        <option name="cessRate" value="142.000">
                          142
                        </option>
                        <option name="cessRate" value="160.000">
                          160
                        </option>
                        <option name="cessRate" value="204.000">
                          204
                        </option>
                        <option name="cessRate" value="290.000">
                          290
                        </option>
                        <option name="cessRate" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                    <td>
                      {/* <input
                    type="text"
                    name="Item_Details_CESS_NonAdvol_Rate"
                    onChange={handleChange}
                    value={ewayBill.Item_Details_CESS_NonAdvol_Rate}
                  /> */}
                      <select
                        className="selectt"
                        name="cessNonAdvol"
                        id="document-type"
                        onChange={handleChange}
                        value={details.cessNonAdvol}
                      >
                        <option name="cessNonAdvol" value="-1">
                          -Select-
                        </option>
                        <option
                          name="cessNonAdvol"
                          selected="selected"
                          value="0.000"
                        >
                          0
                        </option>
                        <option name="cessNonAdvol" value="400.000">
                          400
                        </option>
                        <option name="cessNonAdvol" value="2076.000">
                          2076
                        </option>
                        <option name="cessNonAdvol" value="2747.000">
                          2747
                        </option>
                        <option name="cessNonAdvol" value="3668.000">
                          3668
                        </option>
                        <option name="cessNonAdvol" value="4006.000">
                          4006
                        </option>
                        <option name="cessNonAdvol" value="4170.000">
                          4170
                        </option>
                        <option name="cessNonAdvol" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <label>
              {/* Amount: {details.rate * details.qty} */}
              Amount:{" "}
              {
                details.rate * details.qty
                // (details.amount =
                //   details?.rate * details?.qty +
                //   (details?.rate * details?.qty * details?.sgstRate * 2) / 100 +
                //   (details?.rate * details?.qty * details?.igstRate) / 100 +
                //   (details?.rate * details?.qty * details?.cessRate) / 100 +
                //   Number(details?.cessNonAdvol))
              }
              <input
                type="text"
                name="amount"
                // value={details.rate * details.qty}
                value={details.amount}
                placeholder="write manually"
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Total Chalan Amount:{" "}
              {details?.rate * details?.qty +
                (details?.rate * details?.qty * details?.sgstRate * 2) / 100 +
                (details?.rate * details?.qty * details?.igstRate) / 100 +
                (details?.rate * details?.qty * details?.cessRate) / 100 +
                Number(details?.cessNonAdvol)}
              <input
                type="text"
                name="total_challan_amount"
                // value={(details.total_challan_amount = details.amount)}
                value={details.total_challan_amount}
                onChange={handleChange}
                placeholder="write manually"
              />
            </label>
            <br />
            <label>
              Updated By:
              <input
                type="text"
                name="updatedby"
                value={details.updatedby}
                onChange={handleChange}
              />
            </label>
            <label style={{ marginTop: "10px" }}>
              E-way Bill Number
              <input
                type="text"
                name="e_way_bill_no"
                value={details.e_way_bill_no}
                onChange={handleChange}
              />
            </label>
            <label>
              {/* E-way Bill No: */}
              {
                // JSON.stringify(EwayBillDetails) === {} ? (
                //   <input
                //     type="text"
                //     name="e_way_bill_no"
                //     value={details.e_way_bill_no}
                //     onChange={handleChange}
                //   />
                // ) :
                //(
                // <>
                //   <input type="text" list="e_way_bill_no" />
                //   <datalist
                //     name="e_way_bill_no"
                //     id="e_way_bill_no"
                //     onChange={handleChange}
                //   >
                //     {Object.entries(EwayBillDetails.num).map((item, index) => {
                //       //here we convert object to array and then map it to get the values, how to get last value
                //       if (
                //         index + 1 ===
                //         Object.entries(EwayBillDetails.num).length
                //       ) {
                //         return (
                //           <option
                //             name="e_way_bill_no"
                //             key={index}
                //             value={item[1].ewaybillno}
                //           >
                //             {/* {setewaybillnu(item[1].ewaybillno)} */}
                //             {item[1].ewaybillno}
                //           </option>
                //         );
                //       }
                //     })}
                //   </datalist>
                // </>
                // )
              }
            </label>
            <br />
            {/* <label>
          Client Details
          {JSON.stringify(partyDetails) === {} ? (
            <input
              type="text"
              name="client_details"
              value={details.client_details}
              onChange={handleChange}
            />
          ) : (
            <>
              <input type="text" list="client_name" />
              <datalist
                name="client_details"
                id="client_name"
                onChange={handleChange}
              >
                {Object.entries(partyDetails.client).map((item, index) => {
                  return (
                    <option
                      name="client_details"
                      key={index}
                      value={item[1].name}
                    >
                      {item[1].name}
                    </option>
                  );
                })}
              </datalist>
            </>
          )}
        </label>
        <br /> */}
            <label>
              Bill of Entry No:
              <input
                type="text"
                name="entery_bill_no"
                value={details.entery_bill_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              date
              <input
                type="date"
                name="date"
                value={details.date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GST No:
              <input
                type="text"
                name="gst_no"
                value={details.gst_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Pan No:
              <input
                type="text"
                name="pan_no"
                value={details.pan_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Cin No:
              <input
                type="text"
                name="cin_no"
                value={details.cin_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Gr No:
              <input
                type="text"
                name="gr_no"
                value={details.gr_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GR date:
              <input
                type="text"
                name="gr_date"
                value={details.gr_date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Invoice Number
              <input
                type="text"
                name="invoice_no"
                value={details.invoice_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Invoice Date
              <input
                type="text"
                name="invoice_date"
                value={details.invoice_date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Challan No
              <input
                type="text"
                name="challan_number"
                value={details.challan_number}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Truck No:
              <input
                type="text"
                name="truck_no"
                value={details.truck_no}
                onChange={handleChange}
              />
              {/* {JSON.stringify(trucksDetails) === {} ? (
            <input
              type="text"
              name="truck_no"
              value={details.truck_no}
              onChange={handleChange}
            />
          ) : (
            <>
              <input type="text" list="gaadi_no" />
              <datalist name="truck_no" id="gaadi_no" onChange={handleChange}>
                {Object.entries(trucksDetails.car).map((item, index) => {
                  return (
                    <option
                      name="truck_no"
                      key={index}
                      value={item[1].gaadi_no}
                    >
                      {item[1].gaadi_no}
                    </option>
                  );
                })}
              </datalist>
            </>
          )} */}
            </label>
            <br />
            <label>
              Freight Mode:
              <input
                type="text"
                name="freight_mode"
                value={details.freight_mode}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Freight Type:
              <input
                type="text"
                name="freight_type"
                value={details.freight_type}
                onChange={handleChange}
              />
            </label>
            <br />
            {/* <label>
          Goods:
          <input
            type="text"
            name="goods"
            value={details.goods}
            onChange={handleChange}
          />
        </label>
        <br /> */}
            <label>
              Transporter Name:
              <input
                type="text"
                name="transporter"
                value={details.transporter}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Vessel Name:
              <input
                type="text"
                name="vessel_name"
                value={details.vessel_name}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Exporter Name:
              <input
                type="text"
                name="exporter_name"
                value={details.exporter_name}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              {profileDetails &&
              profileDetails.pro &&
              profileDetails.pro["name"] ===
                "SHREE MAHAVEER TRANSPORT COMPANY" ? (
                <h2>Billed To:</h2>
              ) : (
                <h2>Billed From:</h2>
              )}
              {/* <h2> Billed From:</h2> */}
              <input
                type="text"
                name="billed_to"
                value={details.billed_to}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Address
              <input
                type="text"
                name="billed_to_address"
                value={details.billed_to_address}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              State:
              <input
                type="text"
                name="billed_state"
                value={details.billed_state}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Code:
              <input
                type="number"
                name="billed_code"
                value={details.billed_code}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GST Number:
              <input
                type="text"
                name="billed_gst"
                value={details.billed_gst}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              PAN Number:
              <input
                type="text"
                name="billed_pan"
                value={details.billed_pan}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Weight:
              <input
                type="number"
                name="weight"
                value={details.weight}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Driver Name:
              <input
                type="text"
                name="driver_name"
                value={details.driver_name}
                onChange={handleChange}
              />
              {/* <input
            type="text"
            name="driver_name"
            value={details.driver_name}
            onChange={handleChange}
          /> */}
              {/* <select name="driver_name" id="Driver_name" onChange={handleChange}>
            {Object.entries(driverDetails.drive).map((item, index) => {
              return (
                <option
                  name="driver_name"
                  key={index}
                  value={item[1].driver_name}
                >
                  {item[1].name}
                </option>
              );
            })}
          </select> */}
            </label>
            <br />
            <label>
              {profileDetails &&
              profileDetails.pro &&
              profileDetails.pro["name"] ===
                "SHREE MAHAVEER TRANSPORT COMPANY" ? (
                <h2>Delivery To:</h2>
              ) : (
                <h2>Billed and Delivery To:</h2>
              )}
              {/* <h2> Delivery To:</h2> */}
              <input
                type="text"
                name="delivery_to"
                value={details.delivery_to}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Address
              <input
                type="text"
                name="delivery_to_address"
                value={details.delivery_to_address}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              State:
              <input
                type="text"
                name="delivery_state"
                value={details.delivery_state}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Code:
              <input
                type="number"
                name="delivery_code"
                value={details.delivery_code}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GST Number:
              <input
                type="text"
                name="delivery_gst"
                value={details.delivery_gst}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              PAN Number:
              <input
                type="text"
                name="delivery_pan"
                value={details.delivery_pan}
                onChange={handleChange}
              />
            </label>
            <br />
            <br />
            <label>
              Description Of Goods:
              <input
                type="text"
                name="description_of_goods"
                value={details.description_of_goods}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              HSN CODE:
              <input
                type="text"
                name="hsn_code"
                value={details.hsn_code}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              QTY:
              <input
                type="number"
                name="qty"
                value={details.qty}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              UOM:
              <input
                type="text"
                name="uom"
                value={details.uom}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              rate:
              <input
                type="number"
                name="rate"
                value={details.rate}
                onChange={handleChange}
              />
            </label>
            <br />
            <div>
              <table>
                <thead>
                  <tr>
                    <th>CGST+ SGST Rate(%) </th>
                    <th>IGST Rate(%)</th>
                    <th>CESS Advol Rate(%)</th>
                    <th>CESS non.Advol. Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <select
                        className="selectt"
                        name="sgstRate"
                        id="document-type"
                        onChange={handleChange}
                        value={details.sgstRate}
                      >
                        <option name="sgstRate" value="-1">
                          -Select-
                        </option>
                        <option name="sgstRate" value="0.500">
                          0.500 + 0.500
                        </option>
                        <option name="sgstRate" value="0.750">
                          0.750 + 0.750
                        </option>
                        <option name="sgstRate" value="3.750">
                          3.750 + 3.750
                        </option>
                        <option name="sgstRate" value="0.000">
                          0 + 0{" "}
                        </option>
                        <option name="sgstRate" value="2.500">
                          2.500 + 2.500
                        </option>
                        <option name="sgstRate" value="6.000">
                          6 + 6{" "}
                        </option>
                        <option name="sgstRate" value="9.000">
                          9 + 9{" "}
                        </option>
                        <option name="sgstRate" value="14.000">
                          14 + 14{" "}
                        </option>
                        <option name="sgstRate" value="1.500">
                          1.500 + 1.500
                        </option>
                        <option name="sgstRate" value="0.050">
                          0.050 + 0.050
                        </option>
                        <option name="sgstRate" value="0.125">
                          0.125 + 0.125
                        </option>
                        <option name="sgstRate" value="3.000">
                          3 + 3{" "}
                        </option>
                        <option name="sgstRate" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="selectt"
                        name="igstRate"
                        id="document-type"
                        onChange={handleChange}
                        value={details.igstRate}
                      >
                        <option name="igstRate" value="-1">
                          -Select-
                        </option>
                        <option name="igstRate" value="1.000">
                          1
                        </option>
                        <option name="igstRate" value="1.500">
                          1.500
                        </option>
                        <option name="igstRate" value="7.500">
                          7.500
                        </option>
                        <option name="igstRate" value="0.000">
                          0
                        </option>
                        <option name="igstRate" value="5.000">
                          5
                        </option>
                        <option name="igstRate" value="12.000">
                          12
                        </option>
                        <option name="igstRate" value="18.000">
                          18
                        </option>
                        <option name="igstRate" value="28.000">
                          28
                        </option>
                        <option name="igstRate" value="3.000">
                          3
                        </option>
                        <option name="igstRate" value="0.100">
                          0.100
                        </option>
                        <option name="igstRate" value="0.250">
                          0.250
                        </option>
                        <option name="igstRate" value="6.000">
                          6
                        </option>
                        <option name="igstRate" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="selectt"
                        name="cessRate"
                        id="document-type"
                        onChange={handleChange}
                        value={details.cessRate}
                      >
                        <option value="-1">-Select-</option>
                        <option
                          selected="selected"
                          value="0.000"
                          name="cessRate"
                        >
                          0
                        </option>
                        <option name="cessRate" value="1.000">
                          1
                        </option>
                        <option name="cessRate" value="3.000">
                          3
                        </option>
                        <option name="cessRate" value="5.000">
                          5
                        </option>
                        <option name="cessRate" value="11.000">
                          11
                        </option>
                        <option name="cessRate" value="12.000">
                          12
                        </option>
                        <option name="cessRate" value="12.500">
                          12.500
                        </option>
                        <option name="cessRate" value="15.000">
                          15
                        </option>
                        <option name="cessRate" value="17.000">
                          17
                        </option>
                        <option name="cessRate" value="20.000">
                          20
                        </option>
                        <option name="cessRate" value="21.000">
                          21
                        </option>
                        <option name="cessRate" value="22.000">
                          22
                        </option>
                        <option name="cessRate" value="36.000">
                          36
                        </option>
                        <option name="cessRate" value="49.000">
                          49
                        </option>
                        <option name="cessRate" value="60.000">
                          60
                        </option>
                        <option name="cessRate" value="61.000">
                          61
                        </option>
                        <option name="cessRate" value="65.000">
                          65
                        </option>
                        <option name="cessRate" value="71.000">
                          71
                        </option>
                        <option name="cessRate" value="72.000">
                          72
                        </option>
                        <option name="cessRate" value="89.000">
                          89
                        </option>
                        <option name="cessRate" value="96.000">
                          96
                        </option>
                        <option name="cessRate" value="142.000">
                          142
                        </option>
                        <option name="cessRate" value="160.000">
                          160
                        </option>
                        <option name="cessRate" value="204.000">
                          204
                        </option>
                        <option name="cessRate" value="290.000">
                          290
                        </option>
                        <option name="cessRate" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                    <td>
                      {/* <input
                    type="text"
                    name="Item_Details_CESS_NonAdvol_Rate"
                    onChange={handleChange}
                    value={ewayBill.Item_Details_CESS_NonAdvol_Rate}
                  /> */}
                      <select
                        className="selectt"
                        name="cessNonAdvol"
                        id="document-type"
                        onChange={handleChange}
                        value={details.cessNonAdvol}
                      >
                        <option name="cessNonAdvol" value="-1">
                          -Select-
                        </option>
                        <option
                          name="cessNonAdvol"
                          selected="selected"
                          value="0.000"
                        >
                          0
                        </option>
                        <option name="cessNonAdvol" value="400.000">
                          400
                        </option>
                        <option name="cessNonAdvol" value="2076.000">
                          2076
                        </option>
                        <option name="cessNonAdvol" value="2747.000">
                          2747
                        </option>
                        <option name="cessNonAdvol" value="3668.000">
                          3668
                        </option>
                        <option name="cessNonAdvol" value="4006.000">
                          4006
                        </option>
                        <option name="cessNonAdvol" value="4170.000">
                          4170
                        </option>
                        <option name="cessNonAdvol" value="-2">
                          -Not Appl-
                        </option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <label>
              {/* Amount: {details.rate * details.qty} */}
              Amount:{" "}
              {
                details.rate * details.qty
                // (details.amount =
                //   details?.rate * details?.qty +
                //   (details?.rate * details?.qty * details?.sgstRate * 2) / 100 +
                //   (details?.rate * details?.qty * details?.igstRate) / 100 +
                //   (details?.rate * details?.qty * details?.cessRate) / 100 +
                //   Number(details?.cessNonAdvol))
              }
              <input
                type="text"
                name="amount"
                // value={details.rate * details.qty}
                value={details.amount}
                placeholder="write manually"
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Total Chalan Amount:{" "}
              {details?.rate * details?.qty +
                (details?.rate * details?.qty * details?.sgstRate * 2) / 100 +
                (details?.rate * details?.qty * details?.igstRate) / 100 +
                (details?.rate * details?.qty * details?.cessRate) / 100 +
                Number(details?.cessNonAdvol * details?.qty)}
              <input
                type="text"
                name="total_challan_amount"
                // value={(details.total_challan_amount = details.amount)}
                value={details.total_challan_amount}
                onChange={handleChange}
                placeholder="write manually"
              />
            </label>
            <br />
            <label>
              Updated By:
              <input
                type="text"
                name="updatedby"
                value={details.updatedby}
                onChange={handleChange}
              />
            </label>
            <input className="generate" type="submit" value="Generate Chalan" />
          </form>
          <ChalanRasid chalan={details} />
        </Box>
      </Modal>
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={classes.printContainer}>
          <Printchallanrasid chalan={details} handleClose2={handleClose2} />
        </Box>
      </Modal>
    </Box>
  );
}

export default ShowChalan;
